import React from "react";
import {TableRow, TableCell} from "@mui/material";
import moment from "moment";
import ActionPopperComponent from "./action-popper.component";

const ReportRowData = ({report, index}) => {

    return (
        <>
            <TableRow key={index} sx={{'&:last-child td, &:last-child th': {border: 0}, '& td, & th': {borderBottom: 0}}}>  
                <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                    {report?.report_type}
                </TableCell>

                <TableCell align="left" sx={{color: "#58565F"}}>
                    {report?.generated_by}
                </TableCell>

                <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                    {moment(report?.date_range_start).format('MMMM DD, YYYY HH:mmA')}
                </TableCell>

                <TableCell component="th" scope="row" sx={{color: "#58565F"}}>
                    {moment(report?.date_range_end).format("MMMM DD, YYYY HH:mmA")}
                </TableCell>

                <TableCell component="th" scope="row" sx={{color: 
                        (report?.report_status === "Completed") ? "#40BF7E" 
                    : 
                        (report?.report_status === "Ongoing") ? "#FFA500" 
                    :  
                        (report?.report_status === "Error") ? "#E76C59" 
                    : 
                        null
                }}>
                    {report?.report_status}
                </TableCell>

                <TableCell align="left">
                    <ActionPopperComponent report={report} />
                </TableCell>
            </TableRow>
        </>
    )
}

export default ReportRowData